import { createStore } from "vuex";
import { getCookie, setCookie } from "./utils"; // helpers for cookies

let initialState = {
    // Existing booking, user, admin state
    bookData: {
        id: 0,
        stylist_id: 0,
        services: [],
        date: "",
        hour: "",
        special_event: false,
        notes: "",
        reminders: [],
        reschedule_fee: 0,
        original_date: "",
        selected_service_qty: {},
        book_again: false,
        reschedule: false,
    },
    previewData: { date: "", stylistName: "", services: [] },
    currentBookSection: 1,
    serviceCategories: [],
    services: {},
    selectedServicesDuration: 0,
    freeHours: [],
    stylists: [],
    bookStylists: [],
    selectedStylist: null,
    selectedClient: null,
    userDataLoaded: false,
    isUserGroup: false,
    adminDetails: {},
    showClientsEditForm: false,
    groupMembers: [],
    paymentStylists: [],
    loadingPaymentStylists: false,
    squareCards: {},
    stripeCards: {},
    totalCards: 0,
    clientPaymentsTotal: 0,
    stylistPolicy: { age_limit: 0 },
    translation: {},
    localNotificationCount: 0,
    checkoutAppointentsCount: 0,
    hasPolicyEnabled: false,
    salesSelectedApp: 1,
    defaultCard: {},
    currentWaitingListStylist: {},
    waitingListSettings: {},

    // === ProfileListing specific state ===
    profileLikes: getCookie("profile_likes")
        ? getCookie("profile_likes")
              .split(",")
              .map((id) => parseInt(id) || 0)
        : [],
    currentImageIndex: {}, // track current portfolio image per stylist
};

export default createStore({
    state: { ...initialState },
    mutations: {
        // ==== Existing mutations ====
        setBookData(state, payload) {
            state.bookData = payload;
        },
        setBookSection(state, payload) {
            state.currentBookSection = payload;
        },
        setServices(state, payload) {
            state.services = payload;
        },
        setServiceCategories(state, payload) {
            state.serviceCategories = payload;
        },
        setFreeHours(state, payload) {
            state.freeHours = payload;
        },
        setPreviewData(state, payload) {
            state.previewData = payload;
        },
        setStylists(state, payload) {
            state.stylists = payload;
        },
        setBookStylists(state, payload) {
            state.bookStylists = payload;
        },
        setSelectedStylist(state, payload) {
            state.selectedStylist = payload;
        },
        setSelectedClient(state, payload) {
            state.selectedClient = payload;
        },
        setIsUserGroup(state, payload) {
            state.isUserGroup = payload;
        },
        setSelectedServicesDuration(state, payload) {
            state.selectedServicesDuration = payload;
        },
        setAdminDetails(state, payload) {
            state.adminDetails = payload;
        },
        setShowClientsEditForm(state, payload) {
            state.showClientsEditForm = payload;
        },
        setPaymentStylists(state, payload) {
            state.paymentStylists = payload;
        },
        setLoadingPaymentStylists(state, payload) {
            state.loadingPaymentStylists = payload;
        },
        setStripeCards(state, payload) {
            state.stripeCards = payload;
        },
        setSquareCards(state, payload) {
            state.squareCards = payload;
        },
        setTotalCards(state, payload) {
            state.totalCards = payload;
        },
        setClientPaymentsTotal(state, payload) {
            state.clientPaymentsTotal = payload;
        },
        setStylistPolicy(state, payload) {
            state.stylistPolicy = payload;
        },
        setTranslation(state, payload) {
            state.translation = payload;
        },
        resetState(state) {
            Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
        },
        setLocalNotificationCount(state, payload) {
            state.localNotificationCount = payload;
        },
        setCheckoutAppointentsCount(state, payload) {
            state.checkoutAppointentsCount = payload;
        },
        setHasPolicyEnabled(state, payload) {
            state.hasPolicyEnabled = payload;
        },
        setSalesSelectedApp(state, payload) {
            state.salesSelectedApp = payload;
        },
        setDefaultCard(state, payload) {
            state.defaultCard = payload;
        },
        setCurrentWaitingListStylist(state, payload) {
            state.currentWaitingListStylist = payload;
        },
        setWaitingListSettings(state, payload) {
            state.waitingListSettings = payload;
        },

        // ==== ProfileListing specific mutations ====
        addProfileLike(state, stylistId) {
            if (!state.profileLikes.includes(stylistId)) {
                state.profileLikes.push(stylistId);
                setCookie("profile_likes", state.profileLikes.join(","), 365);
            }
        },
        setCurrentImageIndex(state, { stylistId, index }) {
            state.currentImageIndex[stylistId] = index;
        },
    },
    actions: {
        // ProfileListing actions
        updateProfileLikes({ commit }, stylistId) {
            commit("addProfileLike", stylistId);
        },
        updateCurrentImageIndex({ commit }, payload) {
            commit("setCurrentImageIndex", payload);
        },
        // Add other actions for profile listing if needed
    },
    getters: {
        // ProfileListing getters
        isProfileLiked: (state) => (stylistId) => state.profileLikes.includes(stylistId),
        getCurrentImageIndex: (state) => (stylistId) => state.currentImageIndex[stylistId] || 0,
        // Existing getters can go here
    },
});
